import React from 'react';
import './chapters.scss';

function Chapter4() {
  return (
    <section className="chapters">
      <div className="chapters__copy">
        <h3>Silicon Sea Change</h3>

        <p>
          This shift from steel to silicon is already underway. In 2019, for instance, the average
          ICE vehicle’s bill of materials (BoM) was comprised of 16% low-power electronics. The
          other 84% of materials were mechanical. However, as manufacturers phase out ICEs in favor
          of BEVs, analysts predict that the percentage of electrical components will more than
          double.<sup className="chapters__sup__num">1</sup>
        </p>
        <p>
          This surge in electrical components has led to some growing pains, particularly when it
          comes to sourcing semiconductors. A recent supply chain crisis was particularly painful,
          Weast says, with manufacturing and shipping delays from Southeast Asia resulting in
          “$100,000 vehicles not shipping because a $1.50 microcontroller could not be obtained.”
          Although the global automotive supply chain was stifled during the pandemic, Intel reports
          that it was still able to meet supply orders, shipping 107% of forecasted units to
          automotive customers in 2020 and 2021.
        </p>
        <div className="chapters__footnote">
          <sup className="chapters__footnote__num">1</sup>

          <sup className="chapters__footnote__text">
            <span>
              Roland Berger. (Estimate of 35% includes both low power electronics and high power
              electronics.)
            </span>
            <a
              target="_blank"
              rel="sponsored"
              href="https://www.rolandberger.com/en/Insights/Publications/The-car-will-become-a-computer-on-wheels.html"
            >
              https://www.rolandberger.com/en/Insights/Publications/The-car-will-become-a-computer-on-wheels.html
            </a>
          </sup>
        </div>
      </div>
    </section>
  );
}

export default Chapter4;
